/**
 * Telling envoy where the browser is, once a browser session. The person
 * it was sent for is kept in session storage; with no storage to keep it
 * in, once a page load instead.
 */

export const AREA_HERE_KEY = "jobenvoy-envoy-area-here-v1";

/** The people sent for in this page load, when storage cannot say. */
const sentThisLoad = new Set<string>();

function sessionStore(): Storage | null {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
}

/**
 * Whether to send for `userId` now. Says yes once, and marks it sent, so a
 * second render, a route change or a remount does not send again.
 */
export function claimAreaHere(userId: string, storage: Storage | null = sessionStore()): boolean {
    try {
        if (!storage) throw new Error("no session storage");
        if (storage.getItem(AREA_HERE_KEY) === userId) return false;
        storage.setItem(AREA_HERE_KEY, userId);
        return true;
    } catch {
        if (sentThisLoad.has(userId)) return false;
        sentThisLoad.add(userId);
        return true;
    }
}

/** Takes the mark back after a failure, so the next time the dashboard opens it tries again. */
export function releaseAreaHere(userId: string, storage: Storage | null = sessionStore()): void {
    sentThisLoad.delete(userId);
    try {
        if (storage?.getItem(AREA_HERE_KEY) === userId) storage.removeItem(AREA_HERE_KEY);
    } catch {
        // Nothing kept, nothing to take back.
    }
}
